import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Table } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { FaArrowRight, FaArrowLeft, FaAngleDoubleRight, FaAngleDoubleLeft } from 'react-icons/fa';
import * as api from '~/Services/Service';

var TIPOS_CONTA = [
  { value: '', label: 'Todos' },
  { value: '3', label: '3 - Despesa' },
  { value: '4', label: '4 - Fornecedor' },
  { value: '5', label: '5 - Banco' },
  { value: '6', label: '6 - Interna' },
  { value: '7', label: '7 - Receita' },
  { value: '8', label: '8 - Prest. Serviço' },
];

var ModalImportContas = function (_ref) {
  var show = _ref.show;
  var onHide = _ref.onHide;
  var codigoGE = _ref.codigoGE;
  var gesLookup = _ref.gesLookup;

  var [geBaseSelect, setGeBaseSelect] = useState(null);
  var [tipoConta, setTipoConta] = useState('');
  var [codigoMaior, setCodigoMaior] = useState('');
  var [codigoMenor, setCodigoMenor] = useState('');
  var [apelidoFiltro, setApelidoFiltro] = useState('');
  var [contasDisponiveis, setContasDisponiveis] = useState([]);
  var [contasSelecionadas, setContasSelecionadas] = useState([]);
  var [gesDisponiveis, setGesDisponiveis] = useState([]);
  var [gesSelecionados, setGesSelecionados] = useState([]);
  var [loadingContas, setLoadingContas] = useState(false);
  var [loadingSubmit, setLoadingSubmit] = useState(false);
  var [resultado, setResultado] = useState(null);

  var gesOptions = (gesLookup || []).map(function (g) {
    return { value: g.codigo, label: g.codigo + ' - ' + (g.apelido || '') };
  });

  useEffect(function () {
    if (show) {
      setGeBaseSelect(null);
      setTipoConta('');
      setCodigoMaior('');
      setCodigoMenor('');
      setApelidoFiltro('');
      setContasDisponiveis([]);
      setContasSelecionadas([]);
      setResultado(null);
      // GEs disponíveis = todos exceto o atual; atual pré-selecionado
      var todos = (gesLookup || []).filter(function (g) { return g.codigo !== codigoGE; });
      setGesDisponiveis(todos);
      var geAtual = (gesLookup || []).find(function (g) { return g.codigo === codigoGE; });
      setGesSelecionados(geAtual ? [geAtual] : []);
    }
  }, [show]);

  var carregarContas = async function () {
    if (!geBaseSelect) { toast.warn('Selecione um GE base'); return; }
    setLoadingContas(true);
    try {
      var res = await api.listarContasGE(geBaseSelect.value, {
        tipo: tipoConta || undefined,
        codigo_maior: codigoMaior || undefined,
        codigo_menor: codigoMenor || undefined,
        apelido: apelidoFiltro || undefined,
      });
      setContasDisponiveis(res || []);
    } catch (e) {
      toast.error('Erro ao carregar contas');
    } finally {
      setLoadingContas(false);
    }
  };

  var moverConta = function (conta) {
    var jaEsta = contasSelecionadas.some(function (c) { return c.codigo_conta === conta.codigo_conta; });
    if (!jaEsta) {
      setContasSelecionadas(function (prev) { return prev.concat([conta]); });
    }
    setContasDisponiveis(function (prev) { return prev.filter(function (c) { return c.codigo_conta !== conta.codigo_conta; }); });
  };

  var removerConta = function (conta) {
    setContasSelecionadas(function (prev) { return prev.filter(function (c) { return c.codigo_conta !== conta.codigo_conta; }); });
    setContasDisponiveis(function (prev) { return prev.concat([conta]); });
  };

  var moverTodasContas = function () {
    setContasSelecionadas(function (prev) { return prev.concat(contasDisponiveis); });
    setContasDisponiveis([]);
  };

  var removerTodasContas = function () {
    setContasDisponiveis(function (prev) { return prev.concat(contasSelecionadas); });
    setContasSelecionadas([]);
  };

  var moverGE = function (ge) {
    var jaEsta = gesSelecionados.some(function (g) { return g.codigo === ge.codigo; });
    if (!jaEsta) {
      setGesSelecionados(function (prev) { return prev.concat([ge]); });
    }
    setGesDisponiveis(function (prev) { return prev.filter(function (g) { return g.codigo !== ge.codigo; }); });
  };

  var removerGE = function (ge) {
    if (ge.codigo === codigoGE) { toast.warn('O GE atual não pode ser removido da lista destino'); return; }
    setGesSelecionados(function (prev) { return prev.filter(function (g) { return g.codigo !== ge.codigo; }); });
    setGesDisponiveis(function (prev) { return prev.concat([ge]); });
  };

  var moverTodosGEs = function () {
    setGesSelecionados(function (prev) { return prev.concat(gesDisponiveis); });
    setGesDisponiveis([]);
  };

  var removerTodosGEs = function () {
    var manterAtual = gesSelecionados.filter(function (g) { return g.codigo === codigoGE; });
    var remover = gesSelecionados.filter(function (g) { return g.codigo !== codigoGE; });
    setGesSelecionados(manterAtual);
    setGesDisponiveis(function (prev) { return prev.concat(remover); });
  };

  var handleSubmit = async function () {
    if (contasSelecionadas.length === 0) { toast.warn('Selecione ao menos uma conta'); return; }
    if (gesSelecionados.length === 0) { toast.warn('Selecione ao menos um GE destino'); return; }
    setLoadingSubmit(true);
    setResultado(null);
    try {
      var res = await api.importContasGE({
        ge_origem: geBaseSelect ? geBaseSelect.value : null,
        contas: contasSelecionadas.map(function (c) { return { codigo_conta: c.codigo_conta, apelido: c.apelido, tipo: c.tipo }; }),
        ges_destino: gesSelecionados.map(function (g) { return g.codigo; }),
      });
      setResultado(res);
      if (res.contas_criadas > 0) {
        toast.success(res.contas_criadas + ' conta(s) criada(s) com sucesso!');
      }
    } catch (err) {
      var msg = (err && err.response && err.response.data && err.response.data.message) || 'Erro ao importar contas';
      toast.error(msg);
    } finally {
      setLoadingSubmit(false);
    }
  };

  var painelLista = function (titulo, itens, onClique, labelKey) {
    return (
      <div className="border rounded" style={{ minHeight: '150px', maxHeight: '200px', overflowY: 'auto' }}>
        <div className="px-2 py-1" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
          <small><strong>{titulo}</strong></small>
        </div>
        {itens.length === 0 ? (
          <p className="text-muted small text-center my-3">Nenhum item</p>
        ) : (
          itens.map(function (item, idx) {
            return (
              <div
                key={idx}
                className="px-2 py-1"
                style={{ cursor: 'pointer', borderBottom: '1px solid #f0f0f0', fontSize: '0.85rem' }}
                onClick={function () { onClique(item); }}
                title="Clique para mover"
              >
                {labelKey(item)}
              </div>
            );
          })
        )}
      </div>
    );
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ fontSize: '1.1rem', color: '#fff' }}>Import Contas GEs</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Filtros */}
        <Row className="mb-3">
          <Col md={3}>
            <Form.Label>GE Base</Form.Label>
            <Select
              value={geBaseSelect}
              options={gesOptions}
              onChange={setGeBaseSelect}
              placeholder="Selecione..."
              isClearable
            />
          </Col>
          <Col md={2}>
            <Form.Label>Tipo da Conta</Form.Label>
            <Form.Control
              as="select"
              size="sm"
              value={tipoConta}
              onChange={function (e) { setTipoConta(e.target.value); }}
            >
              {TIPOS_CONTA.map(function (t) { return <option key={t.value} value={t.value}>{t.label}</option>; })}
            </Form.Control>
          </Col>
          <Col md={2}>
            <Form.Label>Código &gt;</Form.Label>
            <Form.Control
              type="number"
              size="sm"
              value={codigoMaior}
              onChange={function (e) { setCodigoMaior(e.target.value); }}
            />
          </Col>
          <Col md={2}>
            <Form.Label>Código &lt;</Form.Label>
            <Form.Control
              type="number"
              size="sm"
              value={codigoMenor}
              onChange={function (e) { setCodigoMenor(e.target.value); }}
            />
          </Col>
          <Col md={2}>
            <Form.Label>Apelido contém</Form.Label>
            <Form.Control
              type="text"
              size="sm"
              value={apelidoFiltro}
              onChange={function (e) { setApelidoFiltro(e.target.value); }}
            />
          </Col>
          <Col md={1} className="d-flex align-items-end">
            <Button size="sm" variant="primary" onClick={carregarContas} disabled={loadingContas}>
              {loadingContas ? '...' : 'Buscar'}
            </Button>
          </Col>
        </Row>

        {/* Dual-list Contas */}
        <Row className="mb-2">
          <Col md={5}>
            {painelLista(
              'Contas disponíveis (' + contasDisponiveis.length + ')',
              contasDisponiveis,
              moverConta,
              function (c) { return c.codigo_conta + ' - ' + (c.apelido || '') + ' [' + c.tipo + ']'; }
            )}
          </Col>
          <Col md={2} className="d-flex flex-column align-items-center justify-content-center">
            <Button size="sm" variant="outline-primary" className="mb-1" onClick={function () { if (contasDisponiveis.length > 0) moverConta(contasDisponiveis[0]); }} title="Mover selecionado">
              <FaArrowRight />
            </Button>
            <Button size="sm" variant="outline-secondary" className="mb-1" onClick={moverTodasContas} title="Mover todos">
              <FaAngleDoubleRight />
            </Button>
            <Button size="sm" variant="outline-secondary" className="mb-1" onClick={removerTodasContas} title="Remover todos">
              <FaAngleDoubleLeft />
            </Button>
            <Button size="sm" variant="outline-danger" onClick={function () { if (contasSelecionadas.length > 0) removerConta(contasSelecionadas[contasSelecionadas.length - 1]); }} title="Remover último">
              <FaArrowLeft />
            </Button>
          </Col>
          <Col md={5}>
            {painelLista(
              'Contas a serem criadas (' + contasSelecionadas.length + ')',
              contasSelecionadas,
              removerConta,
              function (c) { return c.codigo_conta + ' - ' + (c.apelido || '') + ' [' + c.tipo + ']'; }
            )}
          </Col>
        </Row>

        {/* Dual-list GEs */}
        <Row className="mb-2">
          <Col md={5}>
            {painelLista(
              'GEs disponíveis (' + gesDisponiveis.length + ')',
              gesDisponiveis,
              moverGE,
              function (g) { return g.codigo + ' - ' + (g.apelido || ''); }
            )}
          </Col>
          <Col md={2} className="d-flex flex-column align-items-center justify-content-center">
            <Button size="sm" variant="outline-primary" className="mb-1" onClick={function () { if (gesDisponiveis.length > 0) moverGE(gesDisponiveis[0]); }} title="Mover selecionado">
              <FaArrowRight />
            </Button>
            <Button size="sm" variant="outline-secondary" className="mb-1" onClick={moverTodosGEs} title="Mover todos">
              <FaAngleDoubleRight />
            </Button>
            <Button size="sm" variant="outline-secondary" className="mb-1" onClick={removerTodosGEs} title="Remover todos (exceto atual)">
              <FaAngleDoubleLeft />
            </Button>
            <Button size="sm" variant="outline-danger" onClick={function () { if (gesSelecionados.length > 1) removerGE(gesSelecionados[gesSelecionados.length - 1]); }} title="Remover último">
              <FaArrowLeft />
            </Button>
          </Col>
          <Col md={5}>
            {painelLista(
              'Criar no(s) GE(s) (' + gesSelecionados.length + ')',
              gesSelecionados,
              removerGE,
              function (g) { return g.codigo + ' - ' + (g.apelido || ''); }
            )}
          </Col>
        </Row>

        {resultado && (
          <div className="mt-2">
            <strong className="text-success">{resultado.contas_criadas} conta(s) criada(s).</strong>
            {resultado.erros && resultado.erros.length > 0 && (
              <div className="mt-1">
                <strong className="text-danger">Erros:</strong>
                <ul style={{ fontSize: '0.85rem' }}>
                  {resultado.erros.map(function (e, i) { return <li key={i}>{e}</li>; })}
                </ul>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Fechar</Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={loadingSubmit}
          style={{ backgroundColor: '#7bb32e', borderColor: '#7bb32e' }}
        >
          {loadingSubmit ? 'Criando...' : 'Criar Contas'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalImportContas;
